<template>
  <v-menu
    v-model="colorPickerMenu"
    :close-on-content-click="false"
    :nudge-width="200"
    nudge-left="300"
    :attach="attach"
    offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        :color="'transparent'"
        :size="size"
        class="mx-2"
        style="border: 1px solid #e0e0e0; cursor: pointer"
        v-bind="attrs"
        v-on="on"
        :disabled="disabled">
        <v-icon :size="iconSize" :color="displayColor">{{ icon }}</v-icon>
      </v-avatar>
    </template>
    <v-card>
      <v-card-text>
        <v-color-picker
          v-if="colorPickerMenu"
          class="hue-color-picker"
          :value="colorValue || '#547d9a'"
          @input="onColorPickerInput"
          flat
          mode="hexa"
          show-swatches
          :swatches="colorSwatches"
          :swatches-max-height="200"
          @click="onColorPickerInteraction"></v-color-picker>
      </v-card-text>
      <v-card-actions v-if="allowClear">
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="clearColor">Clear</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
import { log, warn, error } from '@/utils/debugLogger';
export default {
  name: 'color-picker-button',
  props: {
    value: {
      type: [String, Object],
      default: null
    },
    attach: {
      type: Boolean,
      default: false
    },
    allowClear: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: [Number, String],
      default: 24
    },
    iconSize: {
      type: [Number, String],
      default: 'default'
    },
    icon: {
      type: String,
      default: 'mdi-palette'
    },
    colorSwatches: {
      type: Array,
      default: () => [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ]
    }
  },
  data() {
    return {
      colorPickerMenu: false,
      colorValue: null,
      hasUserInteracted: false
    }
  },
  computed: {
    displayColor() {
      if (!this.colorValue) return 'grey';
      return this.colorValue?.hex || this.colorValue;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.colorValue = newVal;
      }
    },
    colorValue: {
      handler(newVal) {
        if (this.hasUserInteracted) {
          if (newVal?.hexa) {
            this.$emit('input', newVal.hexa.substring(0, 7));
          } else if (newVal?.hex) {
            this.$emit('input', newVal.hex);
          } else {
            this.$emit('input', newVal);
          }
        }
      },
      deep: true
    },
    colorPickerMenu: {
      handler(newVal) {
        log(`Color picker menu is now ${newVal ? 'open' : 'closed'}`);
        if (!newVal) {
          this.hasUserInteracted = false;
        }
      }
    }
  },
  methods: {
    onColorPickerInput(newColor) {
      // Mark that user has interacted with the color picker
      this.hasUserInteracted = true;
      
      // Remove opacity/alpha channel from the color
      let colorWithoutAlpha = newColor;
      if (newColor && typeof newColor === 'object') {
        // If it's a color object, use the hex property without alpha
        colorWithoutAlpha = newColor.hex || newColor.hexa?.substring(0, 7) || newColor;
      } else if (typeof newColor === 'string' && newColor.length === 9 && newColor.startsWith('#')) {
        // If it's a 9-character hex string (including alpha), remove the last 2 characters
        colorWithoutAlpha = newColor.substring(0, 7);
      }
      
      this.colorValue = colorWithoutAlpha;
    },
    onColorPickerInteraction() {
      // Mark that user has interacted with the color picker
      this.hasUserInteracted = true;
    },
    clearColor() {
      this.hasUserInteracted = true;
      this.colorValue = null;
      // this.colorPickerMenu = false;
      this.$emit('input', null);
    }
  }
}
</script>

<style lang="scss">
.hue-color-picker {
  & .v-color-picker__hue {
    margin-bottom: 0 !important;
  }
  & .v-color-picker__alpha {
    display: none;
  }
}
</style>
